<template>
    <div>
        <div class="hero-page-container">
            <HeroSlider :data="slider" effect="fade"></HeroSlider>
        </div>
        
        <slot name="about"></slot>

        <KeyTopics :data="keyTopics"></KeyTopics>

        <slot name="recommended"></slot>

        <MainPageNews :data="pageNews"></MainPageNews>

        <slot name="sustainability"></slot>

        <slot name="see-also"></slot> 
    </div>
</template>

<script>
import store from '@/store/'
import { AppDeviceEnquire } from '@/utils/mixin'

import Swiper from 'swiper/dist/js/swiper.js'
import HeroSlider from '../hero-slider/hero-slider.js'
import KeyTopics from './components/key-topics/index.js'
import MainPageNews from './components/news-list/index.js'

export default {
    name: 'main-page',
    mixins: [AppDeviceEnquire],
    store,
    data() {
        return {
            data: App.components["home-page"],
            slider: App.components["home-page"]["slider"],
            keyTopics: App.components["home-page"]["key-topics"],
            pageNews: App.components["home-page"]["last-news"],
            sustainabilitySlider: null,
            seeAlsoSlider: null,
            aboutSlider: null
        }
    },
    components: {
        HeroSlider,
        KeyTopics,
        MainPageNews
    },
    methods: {
        initSliders () {
            this.sustainabilitySlider = new Swiper('.sustainability-slider', {
                slidesPerView: 1,
                spaceBetween: 10
            })

            this.seeAlsoSlider = new Swiper('.see-also-slider', {
                slidesPerView: 1,
                spaceBetween: 10
            })

            this.aboutSlider = new Swiper('.about-slider', {
                slidesPerView: 1,
                spaceBetween: 10
            })
        }
    },
    mounted () {
        if (this.device === 'v-mobile' || this.device === 'mobile') {
            this.initSliders()
        }
    },
    watch: {
        device (value) {
            if (value === 'v-mobile' || value === 'mobile') {
                if (this.sustainabilitySlider === null || this.seeAlsoSlider === null || this.aboutSlider === null) {
                    this.initSliders()
                }
            } else {
                if (this.sustainabilitySlider !== null) {
                    this.sustainabilitySlider.destroy(true, true)
                    this.sustainabilitySlider = null
                }
                if (this.seeAlsoSlider !== null) {
                    this.seeAlsoSlider.destroy(true, true)
                    this.seeAlsoSlider = null
                }
                if (this.aboutSlider !== null) {
                    this.aboutSlider.destroy(true, true)
                    this.aboutSlider = null
                }
            }
        }
    },
    computed: {
        device () {
            return this.$store.getters.device
        }
    }
};
</script>

<style lang="scss">
    @import 'components/see-also/see-also.scss';
    @import 'components/sustainability/sustainability.scss';
</style>



// WEBPACK FOOTER //
// frontend/components/main-page/main-page.vue